import React from "react";
import styled, { css } from "styled-components";
import { Organizations, Individuals } from "./InvestorData";
import InvestorCard from "./InvestorCard";
import {
  SectionContainer,
  SectionSubtitle,
  SectionTitle as PrimitiveSectionTitle
} from "screens/Homepage/styles";

const InvestorsSection: React.FC = () => {
  return (
    <Container>
      <TitleSection>
        <SectionTitle>Backed by the best</SectionTitle>
        {/* <SectionSubtitle>We're backed by the world's leading investors.</SectionSubtitle> */}
      </TitleSection>
      <InvestorsWrapper>
        <OrganizationInvestors>
          {Organizations.map((org, key) => (
            <OrganizationLogo key={key} {...org} alt={`${org.alt}-logo`} />
          ))}
        </OrganizationInvestors>
        {/* <IndividualInvestors>
          {Individuals.map((investor, key) => (
            <InvestorCard key={key} {...investor} />
          ))}
        </IndividualInvestors> */}
      </InvestorsWrapper>
    </Container>
  );
};

export default InvestorsSection;

const Container = styled(SectionContainer)`
  ${({ theme }) => css`
    gap: 48px;

    @media (min-width: ${theme.breakpoints.sm}px) {
      gap: 64px;
    }

    @media (min-width: ${theme.breakpoints.xl}px) {
      gap: 80px;
    }
  `}
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 24px;
  width: 100%;
  max-width: 640px;
  text-align: center;
`;

const SectionTitle = styled(PrimitiveSectionTitle)`
  max-width: initial;
  /* Overriding default textAlign: "left" on small screen size */
  text-align: center;
`;

const InvestorsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 48px;
  width: 100%;
`;

const OrganizationInvestors = styled.div`
  ${({ theme }) => css`
    display: grid;
    padding: 24px;
    align-items: center;
    justify-items: center;
    gap: 34px;

    @media (min-width: ${theme.breakpoints.sm}px) {
      grid-template-columns: repeat(1, 1fr);
    }

    @media (min-width: ${theme.breakpoints.md}px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: ${theme.breakpoints.lg}px) {
      grid-template-columns: repeat(3, 1fr);
    }

    background-color: ${theme.colors.gray2};
    border: 1px solid ${theme.colors.gray7};
    box-shadow: 0px 4px 6px -1px rgba(23, 24, 28, 0.25), 0px 2px 4px -2px rgba(23, 24, 28, 0.25);
    border-radius: 8px;
  `}
`;

const OrganizationRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 64px;
  row-gap: 34px;
  max-width: 70%;
`;

const OrganizationLogo = styled.img`
  display: block;
  width: auto;
  height: auto;
  max-height: 36px;
`;

const IndividualInvestors = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;

  @media (max-width: 625px) {
    justify-content: center;
  }
`;
